module.exports = __webpack_public_path__ + "media/images/pc/items/album/premium-de85151ff6d51199c96cd05ff0e0360c.jpg";